import React, {useEffect} from 'react';
import 'swiper/css/bundle';
import '@aws-amplify/ui-react/styles.css';
import {useTenantContext} from './context/TenantContext';
import {AppRoutes} from './AppRoutes';
import {useLocation} from 'react-router-dom';
import {Helmet} from 'react-helmet';

const App = () => {
  const { favicon, slogan, logo, businessName } = useTenantContext();
  const pathname = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <Helmet>
        <meta name="description" content={slogan} />
        <link rel="icon" href={favicon} />

        <meta property="og:title" content={businessName} />
        <meta property="og:description" content={slogan} />
        <meta property="og:image" content={logo} />
      </Helmet>

      <AppRoutes />
    </>
  );
};

export default App;
